import React, { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import ForgotPasswordModal from "../../../components/ForgotPasswordModal";
import useChangePassword from "../../../hooks/useChangePassword";
import { toast } from "react-toastify";

const ProfileChangePassword = () => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    password: "",
    confirmPassword: "",
  });

  const changePasswordMutation = useChangePassword();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCancel = () => {
    setFormData({
      currentPassword: "",
      password: "",
      confirmPassword: "",
    });
  };

  const validateForm = () => {
    if (!formData.currentPassword) {
      toast.error("Please enter your current password");
      return false;
    }
    if (!formData.password) {
      toast.error("Please enter a new password");
      return false;
    }
    if (!formData.confirmPassword) {
      toast.error("Please confirm your new password");
      return false;
    }
    if (formData.password !== formData.confirmPassword) {
      toast.error("New password and confirm password do not match");
      return false;
    }
    if (formData.password.length < 6) {
      toast.error("New password must be at least 6 characters long");
      return false;
    }
    return true;
  };

  const handleSaveChanges = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      const response = await changePasswordMutation.mutateAsync(formData);

      if (response.data === "Password reset successfully") {
        toast.success("Password changed successfully!");
      } else if (response.status === "400 BAD_REQUEST") {
        toast.error(changePasswordMutation.data.message);
      }
      handleCancel(); // Clear form after successful change
    } catch (error) {
      console.error("Failed to change password:", error);
      toast.error("Failed to change password. Please try again.");
    }
  };

  return (
    <div className="noScroll h-90 verticalScroll pb-17">
      <div className="container-fluid p-0">
        <div className="row">
          <div className="col-md-8 small-text">
            <div class="form-group row">
              <label className="col-md-3 col-form-label">
                Current password:
              </label>
              <div className="col-md-8">
                <input
                  type="password"
                  name="currentPassword"
                  className="small-text overlay-input"
                  value={formData.currentPassword}
                  onChange={handleInputChange}
                  placeholder="Enter current password"
                />
                <a
                  href="#"
                  className="primary_text font_light small-text ml-3 decoration-none"
                  data-toggle="modal"
                  data-target="#forgotPassword"
                >
                  Forgot Password?
                </a>
                <ForgotPasswordModal />
              </div>
            </div>
            <div class="form-group row">
              <label className="col-md-3 col-form-label">New password:</label>
              <div className="col-md-8">
                <input
                  type="password"
                  name="password"
                  className="small-text overlay-input"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Enter new password"
                />
              </div>
            </div>
            <div class="form-group row">
              <label className="col-md-3 col-form-label">
                Confirm password:
              </label>
              <div className="col-md-8">
                <input
                  type="password"
                  name="confirmPassword"
                  className="small-text overlay-input"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  placeholder="Confirm new password"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-12 d-flex justify-content-between">
            <button
              type="button"
              className="btn btn_outline_danger rounded overlay-btn"
              onClick={handleCancel}
              disabled={changePasswordMutation.isPending}
            >
              CANCEL
            </button>
            <button
              type="button"
              className="btn btn-outline-primary rounded overlay-btn"
              onClick={handleSaveChanges}
              disabled={changePasswordMutation.isPending}
            >
              {changePasswordMutation.isPending ? "SAVING..." : "SAVE CHANGES"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileChangePassword;
